(function () {
  const drawer = document.querySelector("[data-kbd-cart-drawer]");
  if (!drawer) return;

  const kpoPending = new Set();
  const kpoButtonRestorers = new Map();

  function showButtonProgress(button, message) {
    if (!button) return () => {};
    const priorBusy = button.getAttribute("aria-busy");
    button.setAttribute("aria-busy", "true");
    const originalValue = button.value;
    const originalNodes = button.tagName === "INPUT" ? null : [...button.childNodes];
    if (originalNodes) button.textContent = message;
    else button.value = message;
    return () => {
      if (originalNodes) button.replaceChildren(...originalNodes);
      else button.value = originalValue;
      if (priorBusy === null) button.removeAttribute("aria-busy");
      else button.setAttribute("aria-busy", priorBusy);
    };
  }

  function setKpoPending(owner, pending) {
    if (pending) {
      if (kpoPending.has(owner)) return;
      kpoPending.add(owner);
      const button = owner.nativeForm?.querySelector('button[type="submit"], input[type="submit"]');
      kpoButtonRestorers.set(owner, showButtonProgress(button, owner.dataset.addingText || "Adding…"));
    } else {
      kpoPending.delete(owner);
      kpoButtonRestorers.get(owner)?.();
      kpoButtonRestorers.delete(owner);
    }
  }

  let restoreCheckoutButton;
  function finishCheckout() {
    restoreCheckoutButton?.();
    restoreCheckoutButton = undefined;
  }

  async function withCheckoutProgress(button, action, onError = (error) => setStatus(error.message)) {
    if (restoreCheckoutButton) return;
    restoreCheckoutButton = showButtonProgress(button, "Opening checkout…");
    try {
      if (await action()) return;
    } catch (error) {
      finishCheckout();
      onError(error);
      return;
    }
    finishCheckout();
  }

  window.addEventListener("pageshow", (event) => {
    if (event.persisted) finishCheckout();
  });

  const selectors = {
    bulk: "[data-kbd-cart-bulk]",
    close: "[data-kbd-cart-close]",
    items: "[data-kbd-cart-items]",
    note: "[data-kbd-cart-note]",
    removeSelected: "[data-kbd-cart-remove-selected]",
    selectAll: "[data-kbd-cart-select-all]",
    status: "[data-kbd-cart-status]",
    subtotal: "[data-kbd-cart-subtotal]"
  };

  const state = {
    cart: null,
    globoAddPending: false,
    globoPendingTimer: 0,
    isOpen: false,
    noteTimer: 0,
    returnFocus: null
  };

  const moneyFormat = window.theme && (window.theme.moneyFormatWithCodeForCartPreference || window.theme.moneyFormat);

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function" && moneyFormat) {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    const currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : "USD";
    return new Intl.NumberFormat(document.documentElement.lang || "en", {
      style: "currency",
      currency
    }).format((Number(cents) || 0) / 100);
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function setStatus(message) {
    const status = drawer.querySelector(selectors.status);
    if (status) status.textContent = message || "";
  }

  function updateHeaderCount(cart) {
    document.querySelectorAll(".header-cart__count").forEach(count => {
      count.textContent = cart ? cart.item_count : "0";
    });
  }

  function visibleProperties(item) {
    return Object.entries(item.properties || {}).filter(([key, value]) => value && key.charAt(0) !== "_");
  }

  function giftDeadline(item) {
    if (item.properties?._lucky_drop_gift !== "true" || !item.properties?._lucky_drop_issuance) return null;
    const deadline = Number(item.properties._lucky_drop_expires_at);
    return Number.isSafeInteger(deadline) && deadline > 0 ? deadline : null;
  }

  function updateGiftCountdowns() {
    let expiredOnCartPage = false;
    document.querySelectorAll("[data-lucky-gift-expires]").forEach(element => {
      const remaining = Math.max(0, Math.ceil((Number(element.dataset.luckyGiftExpires) - Date.now()) / 1000));
      const minutes = Math.floor(remaining / 60);
      const seconds = remaining % 60;
      const expired = remaining === 0;
      element.textContent = expired ? "Gift expired — remove before checkout" : `Checkout within ${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")} to claim`;
      element.classList.toggle("is-expired", expired);
      if (expired && /\/cart\/?$/.test(window.location.pathname)) expiredOnCartPage = true;
    });
    document.documentElement.classList.toggle("kbd-lucky-gift-expired", expiredOnCartPage);
  }

  function kpoForForm(form) {
    if (!form) return null;
    if (form.kbdProductOptions) return form.kbdProductOptions;
    const own = form.querySelector("kbd-product-options");
    if (own) return own;
    const id = String(form.querySelector('[name="id"]')?.value || "");
    if (!id) return null;
    const section = form.closest(".shopify-section");
    return [...(section?.querySelectorAll("kbd-product-options") || [])].find((element) => {
      if (String(element.dataset.parentVariantId) === id) return true;
      try { return JSON.parse(element.querySelector("[data-kpo-variants]")?.textContent || "[]").some((variant) => String(variant.id) === id); }
      catch (_) { return false; }
    }) || null;
  }
  function handoffKpo(event, form) {
    const kpo = kpoForForm(form);
    if (!kpo) return false;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (kpo.dataset.ready === "true" && typeof kpo.addToCart === "function") kpo.addToCart();
    else window.alert(drawer.dataset.optionsLoading || "Product options are still loading. Please wait a moment and try again.");
    return true;
  }
  function cartGroupId(item) {
    const properties = item.properties || {};
    if (properties._BundleId) return `kbd:${properties._BundleId}`;
    const kpo = properties._kpo_group || properties._kpo_parent_group;
    if (kpo) return `kpo:${kpo}`;
    const globo = properties._gpo_product_group || properties._gpo_parent_product_group;
    return globo ? `gpo:${globo}` : null;
  }

  function normalizedGloboValue(value) {
    return String(value == null ? "" : value).replace(/\s+/g, " ").trim();
  }

  function globoElements(entries) {
    return (Array.isArray(entries) ? entries : []).flatMap(entry => [entry, ...globoElements(entry.elements)]);
  }

  function expectedGloboAddons(item) {
    const properties = item.properties || {};
    const optionSet = String(properties._has_gpo || "");
    const configs = window.GPOConfigs?.options;
    const config = configs?.[optionSet];
    if (!optionSet) return { optionSet, status: "ready", variants: [] };
    if (!configs) return { optionSet, status: "loading", variants: [] };
    if (!config) return { optionSet, status: "incomplete", variants: [] };

    const normalizedProperties = new Map(
      Object.entries(properties).map(([key, value]) => [normalizedGloboValue(key), value])
    );
    const elements = globoElements(config.elements);
    const configuredFields = new Set(
      elements.map(element => normalizedGloboValue(element.label_on_cart || element.label || element.id)).filter(Boolean)
    );
    const compatibleProperties = new Set(["ETA", "EST"]);
    const hasStaleSelection = Object.entries(properties).some(([key, value]) =>
      key.charAt(0) !== "_"
      && value
      && !compatibleProperties.has(normalizedGloboValue(key).toUpperCase())
      && !configuredFields.has(normalizedGloboValue(key))
    );
    if (hasStaleSelection) return { optionSet, status: "incomplete", variants: [] };

    const variants = [];
    elements.forEach(element => {
      const field = element.label_on_cart || element.label || element.id;
      const selected = normalizedProperties.get(normalizedGloboValue(field));
      if (!selected) return;

      const addon = element.addon_product || {};
      const switchSelected = element.type !== "switch"
        || normalizedGloboValue(selected) === normalizedGloboValue(element.switch_label || "Yes");
      if (addon.variant_id && switchSelected) variants.push(String(addon.variant_id));

      const selectedValues = new Set(String(selected).split(",").map(normalizedGloboValue));
      (element.option_values || []).forEach(value => {
        if (value.variant_id && selectedValues.has(normalizedGloboValue(value.value))) {
          variants.push(String(value.variant_id));
        }
      });
    });
    return { optionSet, status: "ready", variants };
  }

  function cartIntegrityStatus(cart) {
    if (!cart || !Array.isArray(cart.items)) return "loading";
    const kpoParents = cart.items.filter((item) => item.properties?._kpo_group);
    const kpoChildren = cart.items.filter((item) => item.properties?._kpo_parent_group);
    if (kpoChildren.some((child) => !kpoParents.some((parent) => parent.properties._kpo_group === child.properties._kpo_parent_group))) return "incomplete";
    const groups = new Set();
    for (const parent of kpoParents) {
      const group = parent.properties._kpo_group;
      if (groups.has(group)) return "incomplete";
      groups.add(group);
      let expected;
      try { expected = JSON.parse(parent.properties._kpo_expected_addons); } catch (_) { return "incomplete"; }
      if (!expected || typeof expected !== "object" || Array.isArray(expected)) return "incomplete";
      if (!Number.isSafeInteger(Number(parent.quantity)) || Number(parent.quantity) < 1) return "incomplete";
      const children = kpoChildren.filter((child) => child.properties._kpo_parent_group === group);
      if (children.some((child) => String(child.properties._kpo_parent_variant) !== String(parent.variant_id || parent.id))) return "incomplete";
      if (Object.prototype.hasOwnProperty.call(parent.properties, "_kpo_expected_files")) {
        let fileKeys;
        try { fileKeys = JSON.parse(parent.properties._kpo_expected_files); } catch (_) { return "incomplete"; }
        if (!Array.isArray(fileKeys) || fileKeys.length < 1 || fileKeys.length > 32 || new Set(fileKeys).size !== fileKeys.length
          || fileKeys.some((key) => typeof key !== "string" || !key || key !== key.trim() || key.includes("[") || key.includes("]")
            || [...key].some((character) => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127)
            || key.startsWith("_kpo") || ["__proto__", "constructor", "prototype"].includes(key))
          || parent.properties._kpo_parent_group || children.some((child) => child.properties._kpo_group)
          || fileKeys.some((key) => !/^https:\/\/cdn\.shopify\.com\/s\/files\/(?:\d+\/)+uploads\/[^/?#\s]+(?:\?[^#\s]*)?$/.test(parent.properties[key] || ""))) return "incomplete";
      }
      const actual = new Map();
      children.forEach((child) => actual.set(String(child.variant_id || child.id), (actual.get(String(child.variant_id || child.id)) || 0) + Number(child.quantity)));
      const entries = Object.entries(expected);
      if (entries.some(([id, count]) => !/^\d+$/.test(id) || !Number.isSafeInteger(count) || count < 1)) return "incomplete";
      if (entries.reduce((sum, [, count]) => sum + count, 0) !== Number(parent.properties._kpo_addon_count)) return "incomplete";
      if (actual.size !== entries.length || entries.some(([id, count]) => actual.get(id) !== count * Number(parent.quantity))) return "incomplete";
    }
    const parents = cart.items.filter(item => item.properties?._has_gpo);
    for (const parent of parents) {
      const expected = expectedGloboAddons(parent);
      if (expected.status !== "ready") return expected.status;
      const group = parent.properties?._gpo_product_group;
      if (expected.variants.length && !group) return "incomplete";

      const required = new Map();
      expected.variants.forEach(id => required.set(id, (required.get(id) || 0) + (Number(parent.quantity) || 0)));
      for (const [variantId, quantity] of required) {
        const actual = cart.items
          .filter(item => String(item.variant_id) === variantId && String(item.properties?._gpo_parent_product_group || "") === String(group))
          .reduce((total, item) => total + (Number(item.quantity) || 0), 0);
        if (actual < quantity) return "incomplete";
      }
    }
    return "ready";
  }

  function cartIntegrityMessage(status) {
    return status === "loading"
      ? (drawer.dataset.optionsLoading || "Product options are still loading. Please wait a moment and try again.")
      : (drawer.dataset.optionSetIncomplete || "One or more configured products in your cart are incomplete or no longer available. Please remove the affected set and configure it again before checkout.");
  }

  async function verifiedCart() {
    const cart = await requestCart("/cart.js");
    let status = cartIntegrityStatus(cart);
    if (status !== "ready") return { cart, status };

    const products = new Map();
    const addonItems = cart.items.filter(item => item.properties?._kpo_parent_group);
    cart.items.filter(item => item.properties?._has_gpo).forEach(parent => {
      const group = String(parent.properties?._gpo_product_group || "");
      expectedGloboAddons(parent).variants.forEach(variantId => {
        const item = cart.items.find(entry =>
          String(entry.variant_id) === variantId
          && String(entry.properties?._gpo_parent_product_group || "") === group
        );
        if (item) addonItems.push(item);
      });
    });

    try {
      await Promise.all(addonItems.map(async item => {
        if (!item.handle) { status = "incomplete"; return; }
        if (!products.has(item.handle)) products.set(item.handle, requestCart(`/products/${item.handle}.js`));
        const product = await products.get(item.handle);
        const variant = (product.variants || []).find(entry => String(entry.id) === String(item.variant_id));
        if (!variant || variant.available === false) status = "incomplete";
      }));
    } catch (error) {
      status = "loading";
    }
    return { cart, status };
  }

  function showCartPageIntegrity(status) {
    if (!/\/cart\/?$/.test(window.location.pathname)) return;
    const form = document.querySelector('.cart form[action*="/cart"]');
    if (!form) return;
    let warning = form.querySelector("[data-kbd-cart-integrity-warning]");
    if (!warning) {
      warning = document.createElement("p");
      warning.dataset.kbdCartIntegrityWarning = "";
      warning.setAttribute("role", "alert");
      warning.className = "kbd-cart-integrity-warning";
      const finish = form.querySelector(".cart-finish");
      (finish || form).insertAdjacentElement(finish ? "beforebegin" : "beforeend", warning);
    }
    const blocked = status !== "ready";
    warning.hidden = !blocked;
    warning.textContent = blocked ? cartIntegrityMessage(status) : "";
    document.documentElement.classList.toggle("kbd-cart-integrity-blocked", blocked);
  }

  function refreshCartPageIntegrity() {
    if (!/\/cart\/?$/.test(window.location.pathname)) return;
    verifiedCart()
      .then(result => showCartPageIntegrity(result.status))
      .catch(() => showCartPageIntegrity("loading"));
  }

  function groupQuantityUpdates(cart, item, quantity) {
    if (quantity !== 0 || item.properties?._gpo_parent_product_group || item.properties?._kpo_parent_group) {
      throw new Error(drawer.dataset.groupQuantityError || "To change options or quantity, remove this set and add it again from the product page.");
    }
    const group = cartGroupId(item);
    return Object.fromEntries(cart.items.filter(entry => cartGroupId(entry) === group).map(entry => [entry.key, 0]));
  }

  function renderItem(item, index = 0, items = [item]) {
    const bundle = item.properties?._BundleId;
    const isBundleLeader = Boolean(bundle) && !items.slice(0, index).some(entry => entry.properties?._BundleId === bundle);
    const isGloboChild = Boolean(item.properties?._kpo_parent_group || item.properties?._gpo_parent_product_group) || Boolean(bundle && !isBundleLeader);
    const isGloboParent = Boolean(item.properties?._kpo_group || item.properties?._gpo_product_group) || isBundleLeader;
    const isLuckyGift = ["Giveaway Prize Pool", "Random Gift"].includes(item.product_title) &&
      item.properties?._lucky_drop_gift === "true" &&
      Boolean(item.properties?._lucky_drop_issuance);
    const displayTitle = isLuckyGift ? "Random Gift" : item.product_title || item.title;
    const image = item.image
      ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(displayTitle)}" loading="lazy">`
      : "";
    const variant = !isLuckyGift && item.variant_title && item.variant_title !== "Default Title"
      ? `<div class="kbd-cart-drawer__meta">${escapeHtml(item.variant_title)}</div>`
      : "";
    const properties = visibleProperties(item)
      .map(([key, value]) => `<div class="kbd-cart-drawer__property">${escapeHtml(key)}: ${escapeHtml(value)}</div>`)
      .join("");
    const deadline = isLuckyGift ? giftDeadline(item) : null;
    const giftMinimum = isLuckyGift ? Number(item.properties?._lucky_drop_minimum) : 0;
    const minimumNotice = Number.isSafeInteger(giftMinimum) && giftMinimum > 0
      ? `<div class="kbd-lucky-gift-minimum">Minimum order amount: ${formatMoney(giftMinimum)}</div>`
      : "";
    const originalPrice = Number(item.original_price) || 0;
    const finalPrice = Number(item.final_price) || 0;
    const giftIsFree = isLuckyGift && Number(item.original_line_price) > 0 && Number(item.final_line_price) === 0;
    const discountPercent = originalPrice > finalPrice
      ? Math.round(((originalPrice - finalPrice) * 100) / originalPrice)
      : 0;
    const saleLabel = discountPercent > 0
      ? `<span class="product-label product-label--on-sale kbd-sale-label kbd-cart-item__sale" aria-label="Sale: ${discountPercent}%">-${discountPercent}%</span>`
      : "";
    return `
      <article class="kbd-cart-drawer__item" data-kbd-cart-item="${escapeHtml(item.key)}">
        <input class="kbd-cart-drawer__item-check" type="checkbox" data-kbd-cart-item-check value="${escapeHtml(item.key)}" aria-label="Select ${escapeHtml(displayTitle)}" ${isGloboChild ? "disabled" : ""}>
        ${isLuckyGift ? `<div class="kbd-cart-drawer__image">${image}${saleLabel}</div>` : `<a class="kbd-cart-drawer__image" href="${escapeHtml(item.url || "/cart")}">${image}${saleLabel}</a>`}
        <div class="kbd-cart-drawer__item-main">
          <div class="kbd-cart-drawer__item-top">
            ${isLuckyGift ? `<span class="kbd-cart-drawer__title">${escapeHtml(displayTitle)}</span>` : `<a class="kbd-cart-drawer__title" href="${escapeHtml(item.url || "/cart")}">${escapeHtml(displayTitle)}</a>`}
            <span class="kbd-cart-drawer__price${giftIsFree ? " kbd-cart-drawer__price--gift" : ""}">
              ${giftIsFree ? `<s class="kbd-cart-drawer__price-original">${formatMoney(item.original_line_price)}</s><span class="kbd-cart-drawer__price-free">${formatMoney(item.final_line_price)}</span>` : formatMoney(item.final_line_price)}
            </span>
          </div>
          ${variant}
          ${properties}
          ${minimumNotice}
          ${deadline ? `<div class="kbd-lucky-gift-countdown" data-lucky-gift-expires="${deadline}" role="status"></div>` : ""}
          ${isGloboParent ? `<div class="kbd-cart-drawer__meta">${escapeHtml(drawer.dataset.groupQuantityError || "To change options or quantity, remove this set and add it again from the product page.")}</div>` : ""}
          <div class="kbd-cart-drawer__item-bottom">
            <div class="kbd-cart-drawer__qty" aria-label="Quantity">
              ${isGloboChild || isGloboParent ? "" : `<button type="button" data-kbd-cart-qty="${escapeHtml(item.key)}" data-kbd-cart-delta="-1" aria-label="Decrease quantity">−</button>`}
              <span>${item.quantity}</span>
              ${isGloboChild || isGloboParent ? "" : `<button type="button" data-kbd-cart-qty="${escapeHtml(item.key)}" data-kbd-cart-delta="1" aria-label="Increase quantity">+</button>`}
            </div>
            ${isGloboChild ? `<span>${escapeHtml(drawer.dataset.groupIncluded || "Included with main product")}</span>` : `<button class="kbd-cart-drawer__remove" type="button" data-kbd-cart-remove="${escapeHtml(item.key)}">${isGloboParent ? escapeHtml(drawer.dataset.groupRemove || "Remove set") : "Remove"}</button>`}
          </div>
        </div>
      </article>
    `;
  }

  function render(cart) {
    state.cart = cart;
    if (window.GPOConfigs && Array.isArray(cart?.items)) {
      window.GPOConfigs.cart = cart;
    }
    updateHeaderCount(cart);

    const items = drawer.querySelector(selectors.items);
    const subtotal = drawer.querySelector(selectors.subtotal);
    const note = drawer.querySelector(selectors.note);
    const bulk = drawer.querySelector(selectors.bulk);

    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    if (note && document.activeElement !== note) note.value = cart.note || "";
    if (bulk) bulk.hidden = cart.items.length === 0;

    if (!items) return;
    if (!cart.items.length) {
      items.innerHTML = `
        <div class="kbd-cart-drawer__empty">
          <p>Your cart is empty.</p>
          <button type="button" data-kbd-cart-close>Continue shopping</button>
        </div>
      `;
      setStatus("Your cart is empty.");
      return;
    }

    setStatus("");
    items.innerHTML = cart.items.map(renderItem).join("");
    updateGiftCountdowns();
  }

  async function requestCart(path, options) {
    const response = await fetch(path, {
      credentials: "same-origin",
      headers: {
        "Accept": "application/json",
        ...(options && options.headers ? options.headers : {})
      },
      ...options
    });
    if (!response.ok) throw new Error("Cart update failed");
    return response.json();
  }

  async function refresh(cartOverride) {
    if (cartOverride && Array.isArray(cartOverride.items)) {
      render(cartOverride);
      return cartOverride;
    }
    setStatus("Loading cart...");
    const cart = await requestCart("/cart.js");
    render(cart);
    return cart;
  }

  let cartMutationPending = false;

  async function changeLine(key, quantity) {
    if (cartMutationPending) return;
    cartMutationPending = true;
    try {
      setStatus("Updating cart...");
      const currentCart = await requestCart("/cart.js");
      const item = currentCart.items.find(entry => entry.key === key);
      if (!item) { render(currentCart); return; }
      const group = cartGroupId(item);
      const body = group ? { updates: groupQuantityUpdates(currentCart, item, Math.max(0, quantity)) } : { id: key, quantity: Math.max(0, quantity) };
      const cart = await requestCart(group ? "/cart/update.js" : "/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      });
      stopGloboAdd();
      render(cart);
      if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
    } finally {
      cartMutationPending = false;
    }
  }

  async function removeSelected() {
    if (cartMutationPending) return;
    cartMutationPending = true;
    try {
      const selected = Array.from(drawer.querySelectorAll("[data-kbd-cart-item-check]:checked:not(:disabled)"), input => input.value);
      if (!selected.length) return;
      const currentCart = await requestCart("/cart.js");
      const groups = new Set(currentCart.items.filter(item => selected.includes(item.key)).map(cartGroupId).filter(Boolean));
      const updates = {};
      currentCart.items.forEach(item => {
        if (selected.includes(item.key) || groups.has(cartGroupId(item))) updates[item.key] = 0;
      });
      if (!Object.keys(updates).length) return;
      setStatus("Removing selected items...");
      const cart = await requestCart("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates })
      });
      stopGloboAdd();
      render(cart);
      if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
    } finally {
      cartMutationPending = false;
    }
  }

  async function checkout() {
    if (cartMutationPending || state.globoAddPending || kpoPending.size) {
      setStatus(drawer.dataset.updatePending || "Please wait for the cart update to finish.");
      return;
    }
    const result = await verifiedCart();
    if (result.cart.items.some(item => { const deadline = giftDeadline(item); return deadline !== null && deadline <= Date.now(); })) {
      render(result.cart);
      setStatus("Your Random Gift has expired. Remove it before checkout.");
      return;
    }
    if (result.status !== "ready") {
      const message = cartIntegrityMessage(result.status);
      render(result.cart);
      setStatus(message);
      window.alert(message);
      return;
    }
    window.location.href = "/checkout";
    return true;
  }

  function cartFromOpenInput(input) {
    if (input && input.detail && input.detail.cart) return input.detail.cart;
    if (input && Array.isArray(input.items)) return input;
    return null;
  }

  function dismissCompetingCartUi() {
    document.querySelectorAll(".added-notice, .ecom-cart-popup").forEach(element => {
      element.remove();
    });
  }

  function open(input) {
    state.returnFocus = document.activeElement;
    dismissCompetingCartUi();
    drawer.hidden = false;
    requestAnimationFrame(() => {
      drawer.classList.add("is-open");
      document.documentElement.classList.add("kbd-cart-drawer-open");
    });
    state.isOpen = true;
    const closeButton = drawer.querySelector(".kbd-cart-drawer__close");
    if (closeButton) window.setTimeout(() => closeButton.focus(), 240);
    const passedCart = cartFromOpenInput(input);
    if (passedCart) {
      render(passedCart);
      return;
    }
    refresh().catch(error => setStatus(error.message));
  }

  function close() {
    drawer.classList.remove("is-open");
    document.documentElement.classList.remove("kbd-cart-drawer-open");
    state.isOpen = false;
    window.setTimeout(() => {
      if (!state.isOpen) drawer.hidden = true;
    }, 240);
    if (state.returnFocus && typeof state.returnFocus.focus === "function") {
      state.returnFocus.focus();
    }
  }

  const pendingForms = new WeakSet();

  async function addForm(form, submitter) {
    if (pendingForms.has(form)) return false;
    if (submitter && submitter.name === "checkout") return false;
    const action = form.getAttribute("action") || "";
    if (!/\/cart\/add(?:\.js)?/.test(action)) return false;
    pendingForms.add(form);
    try {
      setStatus("Adding item...");
      const response = await fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Accept": "application/json" },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error("Could not add item to cart");
      await refresh();
      open();
      return true;
    } finally {
      pendingForms.delete(form);
    }
  }

  function globoHandoffItems(form) {
    const data = new FormData(form);
    const id = Number(data.get("id"));
    const quantity = Math.max(1, Number(data.get("quantity")) || 1);
    if (!id) return null;

    const properties = {};
    data.forEach((value, key) => {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && value !== "") properties[match[1]] = value;
    });

    const groupInput = form.querySelector('[name="properties[_gpo_product_group]"]');
    const group = String(groupInput?.value || Date.now());
    if (groupInput) groupInput.value = group;
    properties._gpo_product_group = group;

    const sellingPlan = data.get("selling_plan");
    const parent = { id, quantity, properties };
    if (sellingPlan) parent.selling_plan = Number(sellingPlan) || sellingPlan;

    const children = [];
    form.querySelectorAll('.gpo-hidden-inputs [gpo-data-variant-id]:not([disabled])').forEach(input => {
      const field = input.getAttribute("data-field-name") || input.name || "Option";
      const advanced = input.getAttribute("data-advanced-addon") || "";
      const inputQuantity = Math.max(1, Number(input.getAttribute("data-quantity")) || 1);
      const advancedKey = {
        one_time_charge: "_gpo_one_time_charge",
        quantity_fixed: "_gpo_quantity_fixed",
        quantity_fixed_by_merchant: "_gpo_quantity_fixed",
        quantity_dynamic: "_gpo_quantity_dynamic",
        quantity_dynamic_by_merchant: "_gpo_quantity_dynamic",
        quantity_mix: "_gpo_quantity_mix",
        per_character: "_gpo_per_character"
      }[advanced];

      String(input.getAttribute("gpo-data-variant-id") || "").split(",").forEach(raw => {
        const [rawId, rawMixedQuantity] = raw.split("|").map(value => value.trim());
        const childId = Number(rawId);
        if (!childId) return;
        const mixedQuantity = Math.max(1, Number(rawMixedQuantity) || inputQuantity);
        const fixed = ["one_time_charge", "quantity_fixed", "quantity_fixed_by_merchant"].includes(advanced);
        const baseQuantity = advanced === "quantity_mix" ? mixedQuantity : inputQuantity;
        const childProperties = {
          _gpo_parent_product_group: group,
          _gpo_field_name: field
        };
        if (advancedKey) childProperties[advancedKey] = advanced === "quantity_mix" ? mixedQuantity : inputQuantity;
        if (properties.Preorder) childProperties.Preorder = properties.Preorder;
        const child = {
          id: childId,
          quantity: fixed ? baseQuantity : baseQuantity * quantity,
          properties: childProperties
        };
        if (sellingPlan) child.selling_plan = Number(sellingPlan) || sellingPlan;
        children.push(child);
      });
    });

    if (!children.length) return null;
    const items = [parent, ...children];
    if (!window.GPOConfigs?.noNeedReverse) items.reverse();
    return { group, items };
  }

  async function addGloboHandoff(form) {
    if (pendingForms.has(form)) return false;
    const payload = globoHandoffItems(form);
    if (!payload) throw new Error(drawer.dataset.optionsLoading || "Product options are still loading. Please try again.");
    pendingForms.add(form);
    try {
      stopGloboAdd();
      setStatus("Adding configured item...");
      const response = await fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Accept": "application/json", "Content-Type": "application/json" },
        body: JSON.stringify({ items: payload.items })
      });
      if (!response.ok) throw new Error("Could not add the configured item to cart");
      const cart = await refresh();
      const status = cartIntegrityStatus(cart);
      if (status !== "ready") {
        const updates = Object.fromEntries(
          cart.items
            .filter(item => String(item.properties?._gpo_product_group || item.properties?._gpo_parent_product_group || "") === payload.group)
            .map(item => [item.key, 0])
        );
        if (Object.keys(updates).length) {
          await requestCart("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates })
          });
        }
        throw new Error(cartIntegrityMessage(status));
      }
      open(cart);
      return true;
    } finally {
      pendingForms.delete(form);
    }
  }

  function isKpoAddBody(body) {
    if (body instanceof FormData) {
      return ["properties", "items[0][properties]"].some(prefix => {
        const group = body.get(prefix + "[_kpo_group]");
        return typeof group === "string" && group.length > 0 && body.get(prefix + "[_kpo_version]") === "2";
      });
    }
    if (typeof body !== "string") return false;
    try {
      const properties = JSON.parse(body)?.items?.[0]?.properties;
      return properties?._kpo_version === "2" && typeof properties._kpo_group === "string" && properties._kpo_group.length > 0;
    } catch {
      return false;
    }
  }

  const originalFetch = window.fetch ? window.fetch.bind(window) : null;
  if (originalFetch) {
    window.fetch = async function kbdCartDrawerFetch(input, init) {
      const response = await originalFetch(input, init);
      try {
        const url = typeof input === "string" ? input : input && input.url ? input.url : "";
        const path = new URL(url, window.location.origin).pathname;
        const requestMethod = init && init.method ? init.method : input && input.method;
        const method = requestMethod ? String(requestMethod).toUpperCase() : "GET";
        const isCartAdd = method !== "GET" && /\/cart\/add(?:\.js)?$/.test(path);
        if (isCartAdd && isKpoAddBody(init?.body)) return response;
        if (isCartAdd && state.globoAddPending) {
          if (!response.ok) stopGloboAdd();
        } else if (isCartAdd && response.ok) {
          window.setTimeout(() => {
            open();
          }, 80);
        }
      } catch (error) {
        // Cart drawer fallback should never break the original cart request.
      }
      return response;
    };
  }

  drawer.addEventListener("click", event => {
    const closeButton = event.target.closest(selectors.close);
    if (closeButton) {
      close();
      return;
    }

    const removeButton = event.target.closest("[data-kbd-cart-remove]");
    if (removeButton) {
      changeLine(removeButton.dataset.kbdCartRemove, 0).catch(error => setStatus(error.message));
      return;
    }

    const qtyButton = event.target.closest("[data-kbd-cart-qty]");
    if (qtyButton && state.cart) {
      const item = state.cart.items.find(cartItem => cartItem.key === qtyButton.dataset.kbdCartQty);
      if (!item) return;
      const delta = Number(qtyButton.dataset.kbdCartDelta || 0);
      changeLine(item.key, item.quantity + delta).catch(error => setStatus(error.message));
      return;
    }

    if (event.target.closest(selectors.removeSelected)) {
      removeSelected().catch(error => setStatus(error.message));
      return;
    }

    const checkoutButton = event.target.closest("[data-kbd-cart-checkout], .kbd-cart-drawer__checkout");
    if (checkoutButton) {
      event.preventDefault();
      if (state.cart?.items?.some(item => item.properties?._kpo_group)) {
        withCheckoutProgress(checkoutButton, checkout);
      } else {
        checkout().catch(error => setStatus(error.message));
      }
    }
  });

  drawer.addEventListener("change", event => {
    if (event.target.matches(selectors.selectAll)) {
      drawer.querySelectorAll("[data-kbd-cart-item-check]:not(:disabled)").forEach(input => {
        input.checked = event.target.checked;
      });
    }

    if (event.target.matches(selectors.note)) {
      window.clearTimeout(state.noteTimer);
      state.noteTimer = window.setTimeout(async () => {
        try {
          const cart = await requestCart("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ note: event.target.value })
          });
          render(cart);
        } catch (error) {
          setStatus(error.message);
        }
      }, 250);
    }
  });

  function prepareGloboDrawer() {
    const config = window.GPOConfigs;
    const productPage = config?.shop?.settings?.general?.product_page;
    if (!productPage || !document.querySelector(".header-cart__count")) return;
    // Use Globo's own stay-on-page path; it still builds and validates the entire option set.
    productPage.redirect_to_cart = false;
    config.stayOnPdp = true;
    config.customCartCountSelector = ".header-cart__count";
  }

  function isGloboForm(form) {
    return Boolean(form?.querySelector(".gpo-container, .gpo-app, .gpo-hidden-inputs, .gpo-original-atc-button, .gpo-clone-atc-button"));
  }

  function selectedGloboAddonIds(form) {
    return Array.from(form.querySelectorAll('.gpo-hidden-inputs [gpo-data-variant-id]:not([disabled])'))
      .flatMap(input => String(input.getAttribute("gpo-data-variant-id") || "").split(","))
      .map(value => value.split("|")[0].trim())
      .filter(Boolean);
  }

  function globoSelectionStatus(form) {
    const config = window.GPOConfigs;
    const rendered = document.body.hasAttribute("data-gpo-is-enabled");
    const cloneReady = Boolean(form.querySelector(".gpo-clone-atc-button, .gpo-clone-stickyAtc-button"));
    if (!config?.option || !rendered) return "loading";

    const selectedIds = selectedGloboAddonIds(form);
    if (!selectedIds.length) {
      if (cloneReady) return "ready";
      const optionSet = form.querySelector('.gpo-hidden-inputs [name="properties[_has_gpo]"]:not([disabled])');
      const requiresGlobo = form.querySelector('.gpo-hidden-inputs [data-addon-price]:not([disabled]), .gpo-hidden-inputs [data-advanced-addon*="quantity_fixed"]:not([disabled]), .gpo-hidden-inputs [data-advanced-addon*="one_time_charge"]:not([disabled]), .gpo-uploading');
      return optionSet?.value && String(optionSet.value) === String(config.option.id) && !requiresGlobo
        ? "native"
        : "loading";
    }
    if (!Array.isArray(config.addonVariants) || !config.addonVariants.length) return "loading";

    const variants = new Map(config.addonVariants.map(variant => [String(variant.id), variant]));
    const unavailable = selectedIds.some(id => {
      const variant = variants.get(id);
      return !variant || variant.available === false;
    });
    if (unavailable) return "unavailable";
    return "ready";
  }

  function stopGloboAdd() {
    state.globoAddPending = false;
    window.clearTimeout(state.globoPendingTimer);
    state.globoPendingTimer = 0;
  }

  function startGloboAdd() {
    state.globoAddPending = true;
    window.clearTimeout(state.globoPendingTimer);
    state.globoPendingTimer = window.setTimeout(() => {
      stopGloboAdd();
      setStatus(drawer.dataset.optionsLoading || "Product options are still loading. Please try again.");
    }, 30000);
  }

  function blockGloboAdd(event, status) {
    event.preventDefault();
    event.stopImmediatePropagation();
    const unavailableMessage = window.GPOConfigs?.translations?.default?.addtocart?.items_are_no_longer_available;
    const message = status === "unavailable"
      ? (unavailableMessage || "Some selected options are no longer available. Please refresh the page and select your options again.")
      : (drawer.dataset.optionsLoading || "Product options are still loading. Please refresh the page and select your options again before adding to cart.");
    window.alert(message);
  }

  document.addEventListener("click", event => {
    const addButton = event.target.closest('[data-add-to-cart], [name="add"], .gpo-clone-atc-button, .gpo-clone-stickyAtc-button');
    const addForm = addButton?.closest('form[action*="/cart/add"]');
    if (!addForm || !isGloboForm(addForm)) return;
    prepareGloboDrawer();
    const status = globoSelectionStatus(addForm);
    if (status === "native") return;
    if (status === "unavailable") return blockGloboAdd(event, status);
    if (status === "ready") startGloboAdd();
  }, true);

  document.addEventListener("gpoAddedToCart", () => {
    stopGloboAdd();
    const cart = window.GPOConfigs?.cart;
    open(cart);
    const status = cartIntegrityStatus(cart);
    if (status !== "ready") {
      const message = cartIntegrityMessage(status);
      setStatus(message);
      window.alert(message);
    }
  });

  document.addEventListener("gpoValidated", event => {
    if (event.detail?.success === false) stopGloboAdd();
  });

  document.addEventListener("submit", event => {
    const form = event.target.closest("form");
    if (!form) return;
    const submitter = event.submitter || document.activeElement;
    const action = form.getAttribute("action") || "";
    if (!/\/cart\/add(?:\.js)?/.test(action)) return;
    if (event.defaultPrevented) return;
    if (!isGloboForm(form) && handoffKpo(event, form)) return;
    if (isGloboForm(form)) {
      prepareGloboDrawer();
      const status = globoSelectionStatus(form);
      if (status === "unavailable") return blockGloboAdd(event, status);
      if (status !== "native") {
        const globoButton = form.querySelector('.gpo-clone-atc-button, .gpo-clone-stickyAtc-button');
        // After Globo validates a required field it removes its clone button and
        // hands the completed form back to the theme. Add the verified parent
        // and add-ons together so the theme cannot submit only the parent line.
        if (status === "ready" && !globoButton) {
          event.preventDefault();
          event.stopImmediatePropagation();
          addGloboHandoff(form).catch(error => {
            setStatus(error.message);
            window.alert(error.message);
          });
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        if (globoButton) {
          if (!globoButton.disabled) globoButton.click();
          return;
        }
        return blockGloboAdd(event, "loading");
      }
      if (!form.reportValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    addForm(form, submitter).catch(error => {
      setStatus(error.message);
      open();
    });
  }, true);

  const verifiedCheckoutForms = new WeakSet();
  document.addEventListener("submit", event => {
    const form = event.target.closest("form");
    if (!form || !/\/cart\/?$/.test(new URL(form.action || window.location.href, window.location.origin).pathname)) return;
    const submitter = event.submitter || document.activeElement;
    if (!submitter || submitter.name !== "checkout") return;
    if (verifiedCheckoutForms.has(form)) {
      verifiedCheckoutForms.delete(form);
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    if (kpoPending.size) {
      setStatus(drawer.dataset.updatePending || "Please wait for the cart update to finish.");
      return;
    }
    const submitVerifiedCart = async () => {
      const result = await verifiedCart();
      if (result.status !== "ready") {
        const message = cartIntegrityMessage(result.status);
        setStatus(message);
        window.alert(message);
        return;
      }
      verifiedCheckoutForms.add(form);
      if (typeof form.requestSubmit === "function") form.requestSubmit(submitter);
      else window.location.href = "/checkout";
      return true;
    };
    const showCheckoutError = () => window.alert(cartIntegrityMessage("loading"));
    if (form.querySelector("[data-kbd-cart-kpo-parent]")) {
      withCheckoutProgress(submitter, submitVerifiedCart, showCheckoutError);
    } else {
      submitVerifiedCart().catch(showCheckoutError);
    }
  }, true);

  document.addEventListener("click", event => {
    const groupRemove = event.target.closest("[data-kbd-cart-group-remove]");
    if (groupRemove) {
      event.preventDefault();
      if (cartMutationPending) return;
      groupRemove.disabled = true;
      changeLine(groupRemove.dataset.kbdCartGroupRemove, 0)
        .then(() => window.location.reload())
        .catch(error => { open(); setStatus(error.message); groupRemove.disabled = false; });
      return;
    }
    const cartLink = event.target.closest('a[href="/cart"], a[href$="/cart"]');
    if (!cartLink || cartLink.closest("[data-kbd-cart-drawer]")) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    open();
  });

  document.addEventListener("keydown", event => {
    if (event.key === "Escape" && state.isOpen) close();
  });

  window.addEventListener("kbd:cart-updated", open);
  document.addEventListener("cart:refresh", event => {
    const cart = event.detail?.cart;
    if (cart && Array.isArray(cart.items)) {
      render(cart);
      return;
    }
    if (state.isOpen) refresh().catch(error => setStatus(error.message));
  });

  const competingCartUiObserver = new MutationObserver(() => {
    if (state.isOpen) dismissCompetingCartUi();
  });
  competingCartUiObserver.observe(document.body, { childList: true, subtree: true });

  refreshCartPageIntegrity();
  updateGiftCountdowns();
  window.setInterval(updateGiftCountdowns, 1000);

  window.KBDCartDrawer = { open, close, refresh, render, cartIntegrityStatus, kpoVersion: 1, setKpoPending };
})();
